import {
  ADD_LISTENER_EXPULSION_ORDER_TABLE,
  GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER,
  SET_SEARCH_PARAMS_EXPULSION_ORDER,
  UPDATE_EDITABLE_TABLE_DATA_EXPULSION_ORDER,
  SET_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK,
  GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK,
  SET_DATA_FOR_VIEW_EXPULSION_ORDER,
  CLEAR_STATE_EXPULSION_ORDER,
  GET_ALL_EXPULSION_ORDER_LOGBOOK,
  UPDATE_SEARCH_CARD_EXPULSION_ORDER,
  UPDATE_SEARCH_CARD_ORDER_NUM,
} from "../types";

const initialState = {
  data: [],
  searchParams: {
    orderNum: "",
    orderDate: "",
    startDate: "",
    endDate: "",
  },
  dataLogbook: [],
  allDataLogbook: [],
  searchParamsLogbook: {
    surname: "",
    name: "",
    midname: "",
    persNum: "",
    birthDate: "",
    startDate: "",
    endDate: "",
    section: 0,
  },
  dataForTable: [],
  orderNum: null,
  orderDate: null,
  programId: 0,
};

export const expulsionOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_EXPULSION_ORDER:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER:
      return {
        ...state,
        data: action.data,
      };
    case SET_DATA_FOR_VIEW_EXPULSION_ORDER: {
      return {
        ...state,
        dataForTable: action.data.trainingAppList,
        orderDate: action.data.orderDate,
        orderNum: action.data.orderNum,
        programId: action.data.programId,
      };
    }
    case UPDATE_EDITABLE_TABLE_DATA_EXPULSION_ORDER: {
      return {
        ...state,
        dataForTable: action.data,
      };
    }
    case ADD_LISTENER_EXPULSION_ORDER_TABLE: {
      const summaryData = [...action.data, ...state.dataForTable];
      const validatedData = summaryData.reduce((acc, n) => {
        const i = acc.findIndex((m) => m.id === n.id);
        if (!~i) {
          acc.push(n);
          if (~i) {
            acc.splice(i, 1);
          }
        }
        return acc;
      }, []);
      return {
        ...state,
        dataForTable: validatedData,
      };
    }
    case CLEAR_STATE_EXPULSION_ORDER: {
      return {
        ...initialState,
      };
    }
    case SET_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK:
      return {
        ...state,
        searchParamsLogbook: Object.assign(state.searchParamsLogbook, action.data),
      };
    case GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK:
      return {
        ...state,
        dataLogbook: action.data,
      };
    case GET_ALL_EXPULSION_ORDER_LOGBOOK:
      return {
        ...state,
        allDataLogbook: action.data,
      };
    case UPDATE_SEARCH_CARD_EXPULSION_ORDER: {
      return {
        ...state,
        programId: action.data.programId ?? 0,
        orderDate: action.data.orderDate,
        orderNum: action.data.orderNum,
      };
    }
    case UPDATE_SEARCH_CARD_ORDER_NUM:
      return {
        ...state,
        orderNum: action.data,
      };
    default:
      return state;
  }
};
